export default __webpack_public_path__ + "static/media/hylylogo.532e93fd.svg";